module.exports = __webpack_public_path__ + "static/media/left_arrow-512.894e9a48.svg";